/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProperty } from './APIProperty';
import {
    APIPropertyFromJSON,
    APIPropertyFromJSONTyped,
    APIPropertyToJSON,
} from './APIProperty';

/**
 * 
 * @export
 * @interface APIPaginatedPropertyList
 */
export interface APIPaginatedPropertyList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedPropertyList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedPropertyList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedPropertyList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIProperty>}
     * @memberof APIPaginatedPropertyList
     */
    results: Array<APIProperty>;
}

/**
 * Check if a given object implements the APIPaginatedPropertyList interface.
 */
export function instanceOfAPIPaginatedPropertyList(value: object): value is APIPaginatedPropertyList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedPropertyListFromJSON(json: any): APIPaginatedPropertyList {
    return APIPaginatedPropertyListFromJSONTyped(json, false);
}

export function APIPaginatedPropertyListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedPropertyList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIPropertyFromJSON)),
    };
}

export function APIPaginatedPropertyListToJSON(value?: APIPaginatedPropertyList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIPropertyToJSON)),
    };
}

